import type { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";
import { Message } from "element-ui";
import { storageGet } from "@/utils";
import { storageKey } from "@/utils/config";
import store from "@/store";
import router from "@/router";
import dayjs from "dayjs";

let errorMsg = "";
let alertTime = 0;

export const createHttp = (option: AxiosRequestConfig) => {
  const instance = axios.create({
    timeout: 50000,
    ...option,
  });

  instance.interceptors.request.use(
    function (config: any) {
      const token = localStorage.token;

      if (token) {
        config.headers.Authorization = token;
      }

      try {
        const tenant: any = storageGet(storageKey.tenant);

        if (tenant && config.headers.tenantId !== false) {
          config.headers["tenant-id"] = tenant.id;
        } else {
          delete config.headers["tenant-id"];
        }

        const company: any = storageGet(storageKey.company);

        if (company && config.headers.companyId !== false) {
          config.headers["company-id"] = company.id;
        } else {
          delete config.headers["company-id"];
        }
      } catch (e) {
        console.error(e);
      }

      return config;
    },
    function (err: any) {
      return Promise.reject(err);
    }
  );

  const unifyHandle = (responsedata: any) => {
    if (responsedata && responsedata.msg) {
      const now = dayjs().valueOf();

      if (errorMsg !== responsedata.msg || now - alertTime > 1000) {
        errorMsg = responsedata.msg;
        alertTime = now;
        Message.error(responsedata.msg);
      }
    }

    if (responsedata && responsedata.code) {
      if (["100000", "401"].includes(`${responsedata.code}`)) {
        store.commit("logoutUser");
        // setTimeout(() => {
        //   storageClear();
        router.replace("/login");
        // }, 1000);
      }
    }
  };

  instance.interceptors.response.use(
    function (response: AxiosResponse) {
      const responsedata: any = response.data;

      if (
        responsedata &&
        responsedata.code &&
        responsedata.code === 200 &&
        responsedata.success
      ) {
        return Promise.resolve(responsedata.data);
      }

      unifyHandle(responsedata);

      return Promise.resolve(responsedata);
    },
    function (err: any) {
      if (err.response && err.response.data) {
        unifyHandle(err.response.data);
        return Promise.reject(err.response.data);
      }

      return Promise.reject(err.response);
    }
  );

  return instance;
};

export const apiHttp = createHttp({
  // baseURL: /*process.env.VUE_APP_BASE_URL*/ "http://192.168.31.93:8888",
  baseURL: process.env.VUE_APP_BASE_URL,
});
